/* ============================================================
   McLaren Poster Theme — theme.js
   ============================================================ */
(function () {
  'use strict';

  /* ---- Hero zoom on load ---- */
  function initHero() {
    var bg = document.getElementById('mlHeroBg');
    if (bg) setTimeout(function () { bg.classList.add('loaded'); }, 80);
  }

  /* ---- Scroll reveal (features + sizes rows) ---- */
  function initReveal() {
    if (!window.IntersectionObserver) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ml-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.ml-feature-item, .ml-sizes__row').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ---- Gallery thumbnail switcher ---- */
  window.mlSetImg = function (thumb) {
    var main = document.getElementById('mlMainImg');
    if (main) main.src = thumb.src;
    document.querySelectorAll('.ml-gallery__thumb').forEach(function (t) {
      t.classList.remove('active');
    });
    thumb.classList.add('active');
  };

  /* ---- Toast helper ---- */
  function showToast(msg) {
    var t = document.getElementById('mlToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('ml-show');
    setTimeout(function () { t.classList.remove('ml-show'); }, 2600);
  }

  /* ================================================================
     CART DRAWER
     ================================================================ */
  function openCartDrawer() {
    var overlay = document.getElementById('cdOverlay');
    var drawer  = document.getElementById('cdDrawer');
    if (overlay) overlay.classList.add('cd-show');
    if (drawer)  { drawer.classList.add('cd-open'); drawer.setAttribute('aria-hidden', 'false'); }
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  window.openCartDrawer = openCartDrawer;

  function closeCartDrawer() {
    var overlay = document.getElementById('cdOverlay');
    var drawer  = document.getElementById('cdDrawer');
    if (overlay) overlay.classList.remove('cd-show');
    if (drawer)  { drawer.classList.remove('cd-open'); drawer.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }
  window.closeCartDrawer = closeCartDrawer;

  function moneyFmt(cents) {
    return '€' + (cents / 100).toFixed(2);
  }

  function renderCartItems(cart) {
    var itemsWrap = document.getElementById('cdItems');
    var emptyWrap = document.getElementById('cdEmpty');
    var footWrap  = document.getElementById('cdFoot');
    if (!itemsWrap) return;

    itemsWrap.innerHTML = '';

    if (!cart.items || cart.items.length === 0) {
      if (emptyWrap) emptyWrap.style.display = 'flex';
      if (footWrap)  footWrap.style.display  = 'none';
      return;
    }

    if (emptyWrap) emptyWrap.style.display = 'none';
    if (footWrap)  footWrap.style.display  = 'block';

    cart.items.forEach(function (item, idx) {
      var row = document.createElement('div');
      row.className = 'cd-item';
      row.style.animationDelay = (idx * 0.05) + 's';

      var imgUrl = item.image ? item.image.replace(/(\.[a-zA-Z]{3,4})(\?|$)/, '_120x120$1$2') : '';

      row.innerHTML =
        '<div class="cd-item__img-wrap"><img class="cd-item__img" src="' + imgUrl + '" alt="' + (item.product_title || '').replace(/"/g,'') + '"></div>' +
        '<div class="cd-item__info">' +
          '<div class="cd-item__title">' + item.product_title + '</div>' +
          (item.variant_title ? '<div class="cd-item__variant">' + item.variant_title + '</div>' : '') +
          '<div class="cd-item__qty">' +
            '<button aria-label="Reducir cantidad" data-line="' + (idx+1) + '" data-delta="-1">−</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button aria-label="Aumentar cantidad" data-line="' + (idx+1) + '" data-delta="1">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="cd-item__right">' +
          '<div class="cd-item__price">' + moneyFmt(item.final_line_price) + '</div>' +
          '<button class="cd-item__remove" data-line="' + (idx+1) + '">Eliminar</button>' +
        '</div>';

      itemsWrap.appendChild(row);
    });

    /* Bind qty + remove buttons */
    itemsWrap.querySelectorAll('.cd-item__qty button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line  = parseInt(btn.dataset.line, 10);
        var delta = parseInt(btn.dataset.delta, 10);
        var span  = btn.parentNode.querySelector('span');
        var newQty = Math.max(0, parseInt(span.textContent, 10) + delta);
        changeLine(line, newQty);
      });
    });
    itemsWrap.querySelectorAll('.cd-item__remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(parseInt(btn.dataset.line, 10), 0);
      });
    });
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      renderCartItems(cart);
      updateCartTotals(cart);
      updateCartBadge(cart.item_count);
    })
    .catch(function () { showToast('No se pudo actualizar el carrito'); });
  }

  function updateCartTotals(cart) {
    var subtotalEl = document.getElementById('cdSubtotal');
    var countEl    = document.getElementById('cdCount');
    if (subtotalEl) subtotalEl.textContent = moneyFmt(cart.total_price);
    if (countEl) countEl.textContent = '(' + cart.item_count + ')';
  }

  function updateCartBadge(count) {
    var badge = document.getElementById('mlCartBadge');
    var btn   = document.getElementById('mlCartBtn');
    if (badge) badge.textContent = count;
    if (btn) {
      btn.classList.remove('ml-bump');
      void btn.offsetWidth; /* restart animation */
      btn.classList.add('ml-bump');
    }
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartItems(cart);
        updateCartTotals(cart);
        updateCartBadge(cart.item_count);
      })
      .catch(function () {});
  }

  function initCartBadgeOnLoad() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBadge(cart.item_count); })
      .catch(function () {});
  }

  /* Close drawer with ESC key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* ================================================================
     DYNAMIC / AESTHETIC ELEMENTS
     ================================================================ */

  /* ---- Scroll progress bar ---- */
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.className = 'ml-progress';
    bar.id = 'mlProgress';
    document.body.appendChild(bar);

    function update() {
      var scrollTop = window.scrollY;
      var height = document.documentElement.scrollHeight - window.innerHeight;
      var pct = height > 0 ? (scrollTop / height) * 100 : 0;
      bar.style.width = pct + '%';
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---- Grain texture overlay ---- */
  function initGrain() {
    var grain = document.createElement('div');
    grain.className = 'ml-grain';
    document.body.appendChild(grain);
  }

  /* ---- Custom cursor ---- */
  function initCursor() {
    if (window.matchMedia('(max-width: 900px)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    var dot  = document.createElement('div');
    var ring = document.createElement('div');
    dot.className  = 'ml-cursor';
    ring.className = 'ml-cursor-ring';
    document.body.appendChild(dot);
    document.body.appendChild(ring);

    var ringX = 0, ringY = 0, targetX = 0, targetY = 0;

    document.addEventListener('mousemove', function (e) {
      targetX = e.clientX;
      targetY = e.clientY;
      dot.style.left = targetX + 'px';
      dot.style.top  = targetY + 'px';
      dot.classList.add('ml-active');
      ring.classList.add('ml-active');
    });

    function animateRing() {
      ringX += (targetX - ringX) * 0.18;
      ringY += (targetY - ringY) * 0.18;
      ring.style.left = ringX + 'px';
      ring.style.top  = ringY + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    document.addEventListener('mouseover', function (e) {
      var t = e.target.closest('a, button, .ml-option-btn, .cd-item, [role="button"]');
      if (t) { dot.classList.add('ml-hover'); ring.classList.add('ml-hover'); }
    });
    document.addEventListener('mouseout', function (e) {
      var t = e.target.closest('a, button, .ml-option-btn, .cd-item, [role="button"]');
      if (t) { dot.classList.remove('ml-hover'); ring.classList.remove('ml-hover'); }
    });
    document.addEventListener('mouseleave', function () {
      dot.classList.remove('ml-active'); ring.classList.remove('ml-active');
    });
  }

  /* ---- Generic scroll reveal for any [data-reveal] element sitewide ---- */
  function initGenericReveal() {
    if (!window.IntersectionObserver) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ml-visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach(function (el) { obs.observe(el); });
  }

  /* ---- Product variant logic ---- */
  var currentVariantId = null;
  var productVariants   = [];
  var selectedOptions   = [];

  function initProduct() {
    var el = document.getElementById('ml-product-data');
    if (!el) return;

    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }

    productVariants = data.variants || [];

    /* ---- Build selectors from options (for homepage section) ---- */
    var colorWrap = document.getElementById('mlColors');
    var sizeWrap  = document.getElementById('mlSizes');

    if (colorWrap && sizeWrap && data.options && data.options.length > 0) {
      /* Collect unique values per option */
      var opts = [];
      data.options.forEach(function (opt) {
        var vals = [];
        productVariants.forEach(function (v) {
          var parts = v.title.split(' / ');
          var idx   = data.options.indexOf(opt);
          if (idx === -1) return;
          var val   = parts[idx];
          if (val && vals.indexOf(val) === -1) vals.push(val);
        });
        opts.push({ name: opt, values: vals });
      });

      selectedOptions = opts.map(function (o) { return o.values[0]; });

      /* Render option 1 → colors */
      if (opts[0]) {
        document.getElementById('mlColorSelector').style.display = '';
        opts[0].values.forEach(function (val, i) {
          var btn = document.createElement('button');
          btn.className = 'ml-option-btn' + (i === 0 ? ' active' : '');
          btn.textContent = val;
          btn.dataset.optIdx = 0;
          btn.dataset.val = val;
          btn.onclick = function () { mlSelectOpt(0, val, this); };
          colorWrap.appendChild(btn);
        });
        document.getElementById('mlColorLabel').textContent = opts[0].values[0] || '';
      }

      /* Render option 2 → sizes */
      if (opts[1]) {
        document.getElementById('mlSizeSelector').style.display = '';
        opts[1].values.forEach(function (val, i) {
          var btn = document.createElement('button');
          btn.className = 'ml-option-btn' + (i === 0 ? ' active' : '');
          btn.textContent = val;
          btn.dataset.optIdx = 1;
          btn.dataset.val = val;
          btn.onclick = function () { mlSelectOpt(1, val, this); };
          sizeWrap.appendChild(btn);
        });
        document.getElementById('mlSizeLabel').textContent = opts[1].values[0] || '';
      }

      updateVariant();
    } else {
      /* Single-option or product.liquid — use first available variant */
      if (productVariants.length > 0) {
        currentVariantId = productVariants[0].id;
        updateVariant();
      }
    }
  }

  function mlSelectOpt(optIdx, val, btn) {
    selectedOptions[optIdx] = val;

    /* Update label */
    var labelId = optIdx === 0 ? 'mlColorLabel' : 'mlSizeLabel';
    var label   = document.getElementById(labelId);
    if (label) label.textContent = val;

    /* Update active class */
    var container = btn.closest('.ml-selector__options');
    if (container) {
      container.querySelectorAll('.ml-option-btn').forEach(function (b) {
        b.classList.toggle('active', b.dataset.val === val);
      });
    }
    updateVariant();
  }

  /* Also used by product.liquid for per-option buttons */
  window.mlSelectOption = function (btn, optIdx, labelIdx) {
    var val = btn.dataset.value;
    selectedOptions[optIdx] = val;

    var labelEl = document.getElementById('mlOpt' + labelIdx + 'Label');
    if (labelEl) labelEl.textContent = val;

    btn.closest('.ml-selector__options').querySelectorAll('.ml-option-btn').forEach(function (b) {
      b.classList.toggle('active', b.dataset.value === val);
    });
    updateVariant();
  };

  function updateVariant() {
    /* Find matching variant */
    var match = productVariants.find(function (v) {
      var parts = v.title.split(' / ');
      return selectedOptions.every(function (sel, i) {
        return !sel || parts[i] === sel;
      });
    });

    var addBtn = document.getElementById('mlAddBtn');

    if (match) {
      currentVariantId = match.id;
      var priceEl = document.getElementById('mlPrice');
      if (priceEl) {
        priceEl.textContent = '€' + match.price.toFixed(2);
      }
      var buyBtn = document.getElementById('mlBuyBtn');
      if (buyBtn) {
        var base = buyBtn.href.split('?')[0];
        buyBtn.href = base + '?variant=' + match.id;
      }

      if (addBtn) {
        if (match.available === false) {
          if (!addBtn.dataset.label) addBtn.dataset.label = addBtn.textContent;
          addBtn.disabled = true;
          addBtn.classList.add('ml-soldout');
          addBtn.textContent = 'Agotado';
        } else {
          addBtn.disabled = false;
          addBtn.classList.remove('ml-soldout');
          if (addBtn.dataset.label) addBtn.textContent = addBtn.dataset.label;
        }
      }
    } else {
      currentVariantId = null;
    }
  }

  /* ---- Add to cart ---- */
  window.mlAddToCart = function () {
    if (!currentVariantId) {
      showToast('Selecciona las opciones');
      return;
    }
    var btn = document.getElementById('mlAddBtn');
    if (btn && btn.disabled) {
      showToast('Este tamaño está agotado');
      return;
    }
    var origText = btn ? (btn.dataset.label || btn.textContent) : '';
    if (btn) { btn.classList.add('ml-loading'); btn.textContent = 'Añadiendo...'; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: currentVariantId, quantity: 1 })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Error');
      return r.json();
    })
    .then(function () {
      if (btn) { btn.classList.remove('ml-loading'); btn.classList.add('ml-success'); btn.textContent = '✓ Añadido'; }
      showToast('✓ Añadido al carrito');
      openCartDrawer();
      setTimeout(function () {
        if (btn) { btn.classList.remove('ml-success'); btn.textContent = origText; }
      }, 2800);
    })
    .catch(function () {
      if (btn) { btn.classList.remove('ml-loading'); btn.textContent = origText; }
      showToast('Error al añadir. Inténtalo de nuevo.');
    });
  };

  /* ---- Site-wide add-to-cart interception (car posters section) ---- */
  window.cpAddToCart = function (variantId) {
    var btn = event.target;
    var origText = btn.textContent;
    btn.textContent = 'Añadiendo...';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () {
      btn.textContent = '✓ Añadido';
      showToast('✓ Añadido al carrito');
      openCartDrawer();
      setTimeout(function () { btn.textContent = origText; btn.disabled = false; }, 2000);
    })
    .catch(function () {
      btn.textContent = origText;
      btn.disabled = false;
      showToast('Error al añadir');
    });
  };

  /* ---- Nav scroll behaviour ---- */
  function initNav() {
    document.querySelectorAll('a[href="#ml-product"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.getElementById('ml-product');
        if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
      });
    });
  }

  /* ---- Bootstrap ---- */
  function init() {
    initHero();
    initReveal();
    initGenericReveal();
    initProduct();
    initNav();
    initScrollProgress();
    initGrain();
    initCursor();
    initCartBadgeOnLoad();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
